export const ENV = {
  COMMIT: process.env.VUE_APP_COMMIT,
  VERSION: process.env.VUE_APP_VERSION,
  BUILD_DATE: process.env.VUE_APP_BUILD_DATE,
  CAST_RECEIVER_ID: process.env.VUE_APP_RECEIVER_ID,
  IS_PRODUCTION: Boolean(PRODUCTION),
  IS_DEVELOPMENT: !PRODUCTION,
  NODE_ENV: process.env.NODE_ENV,
};

export const logBuildInfo = () => {
  console.info(
`Build info:
- BUILD_DATE: ${process.env.VUE_APP_BUILD_DATE};
- VUE_APP_VERSION: ${process.env.VUE_APP_VERSION};
- VUE_APP_COMMIT: ${process.env.VUE_APP_COMMIT};
- NODE_ENV: ${process.env.NODE_ENV};`
  );
};

export const getAppVersion = () => {
  if (ENV.VERSION === '0.0.0') {
    // Local build
    return `Commit ${ENV.COMMIT}`;
  } else if (ENV.VERSION.startsWith('0.0.0-master')) {
    // Public build from master (version e.g. 0.0.0-master-87)
    return `Master Commit ${ENV.COMMIT}`;
  } else {
    // Public release build (version e.g. 6.2.8)
    return `Version ${ENV.VERSION}`;
  }
};
